import * as yup from 'yup';


export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 256;


export const SCHEMA_PASSWORD = yup.string()
    .nullable()
    .min(PASSWORD_MIN_LENGTH)
    .max(PASSWORD_MAX_LENGTH)
    .required();

export const SCHEMA_PASSWORD_CONFIRMATION = yup.string()
    .nullable()
    .min(PASSWORD_MIN_LENGTH)
    .max(PASSWORD_MAX_LENGTH)
    .when(
        'password',
        (password, schema) => schema.test(
            'mismatch',
            '${passwordConfirmation} is not matching',
            passwordConfirmation => passwordConfirmation === password
        )
    )
    .required();

export const SCHEMA_PASSWORD_CONFIRMATION_FORM = yup.object()
    .shape({
        password: SCHEMA_PASSWORD,
        passwordConfirmation: SCHEMA_PASSWORD_CONFIRMATION
    });
